module.exports = __webpack_public_path__ + "react-feature.3g13zblm.svg";